import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Table } from 'primeng/table';
import { UtilStorageService } from 'src/app/admihair/service/util-storage.service';
import { Empresa } from 'src/app/admihair/api/dto/empresa';
import { ConfirmationService, Message } from 'primeng/api';
import { PlanoContaMatrizService } from 'src/app/admihair/service/plano-conta-matriz.service';
import { PlanoContaMatriz } from 'src/app/admihair/api/dto/plano-conta-matriz';
import { ErroService } from 'src/app/admihair/service/erro.service';
import { PlanoContaGrupoService } from 'src/app/admihair/service/plano-conta-grupo.service';
import { PlanoContaAgrupado } from 'src/app/admihair/api/dto/plano-conta-agrupado';

interface expandedRows {
    [key: string]: boolean;
}

@Component({
  selector: 'app-plano-conta-matriz-listar',
  templateUrl: './plano-contas-matriz-listar.component.html',
  styleUrls: ['./plano-contas-matriz-listar.component.scss']
})
export class PlanoContaMatrizListarComponent implements OnInit {
  
  loading: boolean = false;
  loadingRelatorio: boolean = false;
  messages: Message[] = [];
  messagemVisivel: boolean = false;
  progressoRequisicao: boolean = false;
  empresaSelecionada?: Empresa;
  planosContasMatriz: PlanoContaMatriz[] = [];

  listaPlanoContasAgrupados: PlanoContaAgrupado[] = [];
  expandedRows: expandedRows = {};
  

  constructor(private utilStorageService: UtilStorageService,
    private planoContaMatrizService: PlanoContaMatrizService,
    private planoContaGrupoService: PlanoContaGrupoService,
    private confirmationService: ConfirmationService,
    private erroService: ErroService,
    private _router: Router,
    private _activatedRoute: ActivatedRoute) { }

  
  @ViewChild('filter') filter!: ElementRef;
  ngOnInit(): void {
    this.progressoRequisicao = true;
    this.empresaSelecionada = this.utilStorageService.getEmpresa();
    this.listarPlanosContaMatriz();

  }

  listarPlanosContaMatriz() {
    this.loading = true;
    this.planoContaMatrizService.listarAgrupado().subscribe({
      next: (data: PlanoContaAgrupado[]) => {
        this.listaPlanoContasAgrupados = data;
        this.loading = false;
      },
      error: (err: any) => {
        this.loading = false;
        this.messages = this.erroService.handleErro(err);
        this.messagemVisivel = true;
        this.progressoRequisicao = false;
      }
    })
    
    
  }


  editarPlanoContaMatriz(id: number){
    this._router.navigate(["/rfarias/plano-contas-matriz/editar/" + id], { relativeTo: this._activatedRoute })
  }

  excluirPlanoContaMatriz(contaId: number){

    this.confirmationService.confirm({
      message: 'Tem certeza que seja excluir?',
      header: 'Confirmação',
      acceptLabel: 'Sim',
      rejectLabel: 'Não',
      icon: 'pi pi-info-circle',
      accept: () => {
        this.planoContaMatrizService.excluir(contaId).subscribe({
          next: () => {
            this.listarPlanosContaMatriz();
            this.messages = this.erroService.handleSuccess();
            this.messagemVisivel = true;
            this.rolarTela();
          },
          error: (err: any) => {
            this.messages = this.erroService.handleErro(err);
            this.messagemVisivel = true;
            this.rolarTela();
          }
        });
      }
    });
  }

  expandAllRows(dt: Table) {
    //dt.expandedRowKeys = dt.value.map(row => row['planoContaGrupo.descricao']); // Assuming dataKey is 'planoContaGrupo.descricao'
  }

  buscar(table: Table, event: Event) {
    table.filterGlobal((event.target as HTMLInputElement).value, 'contains');
  }

  limpar(table: Table) {
    table.clear();
    this.filter.nativeElement.value = '';
  }

  rolarTela(){
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }

  obterRelatorio() {
    this.loadingRelatorio = true;
    this.planoContaMatrizService.obterRelatorio().subscribe({
      next: (data: any) => {

        const blob = new Blob([data], { type: 'application/pdf' });
        const url = window.URL.createObjectURL(blob);

        window.open(url, '_blank');

        window.URL.revokeObjectURL(url);
        this.loadingRelatorio = false;

      },
      error: (err: any) => {
        this.loadingRelatorio = false;
        this.messages = this.erroService.handleErro(err);
            this.messagemVisivel = true;
            this.rolarTela();
      }
    })
  }

}
